export default __webpack_public_path__ + "static/media/111.2fdc15db.jpg";